/**
 * Position error object
 *
 * @constructor
 * @param code
 * @param message
 */

export class PositionError {
    public watchId: null | number = null
    constructor(
        public code: number | null = null,
        public message = "",
    ) {}

    static PERMISSION_DENIED = 1
    static POSITION_UNAVAILABLE = 2
    static TIMEOUT = 3
    static REQUEST_TIMEOUT = 101
    static GEOLOCATION_UNAVAILABLE = 102
}
